import {on, find, findAll, hasClass} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

const selectors = {
    base: '.js-tabbing-dropdown',
    item: '.js-tabbing-dropdown__item',
    activeItem: '.js-tabbing-dropdown__active-item',
}
export function init() {
    onFind(selectors.base, function (element) {
        const items = findAll(selectors.item, element);
        const activeItem = find(selectors.activeItem, element);

        items.forEach((item) => {
            on("click", function (event) {
                activeItem.innerHTML = item.innerHTML;
            }, item);
        })


    });
}